import React from "react";
import { BsyUtils } from "../../utils/Utils";
import "./index.css";
import { BsyWidget } from "../BsyWidget";
import BsyTree from "../BsyTree";
import BsyIconBtn from "../BsyIconBtn";
import BsyTreeSeach from "../BsyTree/BsyTreeSeach";
import _ from "lodash";

export class ShowTreePane extends BsyWidget {
  constructor(props) {
    super({
      minWidth: 100,
      baseCls: "bsy-show-tree-pane",
      ...props,
    });

    this.state = {
      datalist: [],
      seachKey: "",
      allowAdd: props.allowAdd,
      loading: false,
      search: null,
    };

    this.value = [];
  }

  componentDidMount() {
    super.componentDidMount();
  }

  reload = (config) => {
    this.setState({ search: config.search }, () => {
      this.componentContext.nodeData = _.merge(
        this.componentContext.nodeData,
        this.componentSeachContext.nodeData
      );
      this.componentSeachContext.nodeData = _.merge(
        this.componentContext.nodeData,
        this.componentSeachContext.nodeData
      );
      if (config.search)
        this.componentSeachContext.loadData({}, () => {
          this.componentSeachContext.setState(
            {
              value: this.value,
            },
            () => {
              this.componentSeachContext.rsyncTreeNodeValue();
            }
          );
        });
      this.componentContext.setState({
        value: this.value,
      });
    });
  };

  loadData = (config, cb) => {
    let that = this;
    const { treeFields, fields } = this.options;
    const { search } = this.state;

    let data = {
      widget: {
        fields: fields,
        forms: [that.options.forms],
        type: "data_tree",
        formulas: [],
        filter: this.options.filter,
        treeFields: { ...treeFields, ...config },
      },
      limit: 20,
      skip: 0,
      appId: that.options.appId,
      entryId: that.options.entryId,
      rowOrder: {},
      top: {},
      hasCount: true,
      popupFormPath: [],
      designAppId: that.options.designAppId,
      designEntryId: that.options.designEntryId,
      designWidget: that.options.designWidget,
      //  有具体的节点信息，就走默认的逻辑，没有节点信息时候，搜索才生效
      search: !BsyUtils.isObjectEmpty(config)
        ? undefined
        : search
        ? search
        : undefined,
      // filter: {
      //   rel: this.rel,
      //   cond: this.filter,
      // },
    };

    React.axios(`/data/formdataload`, data).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        cb && cb(res.data.data, search);
      });
    });
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  getValue = () => {
    const { search } = this.state;
    if (search) return this.componentSeachContext._getCheckData();
    return this.componentContext._getCheckData();
  };

  getSeachContext = (context) => {
    this.componentSeachContext = context;
  };

  tableBody = () => {
    const { search } = this.state;
    const { dataloadmode, treeFields, isSubform } = this.options;

    return (
      <div
        className={`data-body ${
          !BsyUtils.isObjectEmpty(dataloadmode) ? "has-menu" : ""
        }`}
      >
        <BsyTreeSeach
          style={{ display: search ? "" : "none" }}
          getContext={this.getSeachContext}
          multi={isSubform}
          {...treeFields}
          key={"bys0tryy-seach"}
          onChangeData={(val) => {
            this.value = [...val];
          }}
          onGetData={(node, cb) => {
            this.loadData(node, cb);
          }}
          onSelectData={this.props.onSelectData}
        />

        <BsyTree
          style={{ display: search ? "none" : "" }}
          getContext={this.getContext}
          multi={isSubform}
          {...treeFields}
          key={"bys0tryy"}
          onChangeData={(val) => {
            this.value = [...val];
          }}
          onGetData={(node, cb) => {
            this.loadData(node, cb);
          }}
          onSelectData={this.props.onSelectData}
        />
      </div>
    );
  };

  renderFooter = () => {
    const { dataloadmode, isSubform } = this.options;

    return (
      <div
        className="menu"
        style={{
          height: "39px",
          background: "#fff",
        }}
      >
        <span className="tip1">{React.language("dataload.tree.tip1")}</span>
        {isSubform ? (
          <>
            {dataloadmode.indexOf("cover") > -1 ? (
              <BsyIconBtn
                text={React.language("cover.data")}
                click={() => {
                  this.props.onMultiSelect("cover");
                  if (this.showPopRef) {
                    this.showPopRef.closeAlter();
                    this.showPopRef = null;
                  }
                }}
                type={"blue"}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
            {dataloadmode.indexOf("add") > -1 ? (
              <BsyIconBtn
                text={React.language("add.data")}
                click={() => {
                  this.props.onMultiSelect("add");
                  if (this.showPopRef) {
                    this.showPopRef.closeAlter();
                    this.showPopRef = null;
                  }
                }}
                type={"blue"}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  render() {
    const { cssName, isSubform } = this.options;

    return (
      <div className={cssName}>
        {this.tableBody()}
        {this.renderFooter()}
      </div>
    );
  }
}
